/* eslint-disable @typescript-eslint/naming-convention */
export class TimeBombConstants {
	// month start from 0, 2 is March
	public static readonly TIME_BOMB_DATE = new Date(2022, 10, 25);
	public static readonly TIME_BOMB_THRESHOLD = 14;
}
